import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Batch, BatchOrder, BatchOrdersRepositoryService, EnumeratedTypesRepositoryService, FilterComponent, FiltersComponent, SelectOption } from 'reg-hub-common';
import { EnvironmentUrlService } from '../../services/environment-url/environment-url.service';
import { forkJoin, take } from 'rxjs';

@Component({
    selector: 'app-batch-orders-filter',
    templateUrl: './batch-orders-filter.component.html',
    styleUrl: './batch-orders-filter.component.css',
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BatchOrdersFilterComponent extends FiltersComponent<BatchOrder> implements OnInit {
  @Input() batch!: Batch;

  protected _orderStatusTypeOptions: SelectOption[] = [];

  protected autoExpand: boolean = false;

  constructor(
    private batchOrdersRepo: BatchOrdersRepositoryService,
    private enumerationRepo: EnumeratedTypesRepositoryService,
    private environment: EnvironmentUrlService,
    private route: ActivatedRoute,
    formBuilder: FormBuilder,
    datePipe: DatePipe) {
    super(
      batchOrdersRepo,
      formBuilder,
      datePipe);
  }

  ngOnInit(): void {
    this.batchOrdersRepo.populateBaseLink([this.batch.bundleID, this.batch.id]);

    let requests = [
      this.enumerationRepo.getOrderStatusTypesAsSelectOptions(this.environment.urlAddress),
    ]

    forkJoin(requests).subscribe(values => {
      this._orderStatusTypeOptions = values[0];
    })

    this._filterForm = this.formBuilder.group({
      orderStatusTypeIDs: [null],
      isSubmitted: [null],
      isStaged: [null],
      hasParsingErrors: [null],
      hasRequestErrors: [null],
      hasRequestWarnings: [null]
    })

    this._defaultParams = this.buildParamsFromForm(this._filterForm);

    this.route.queryParams.pipe(take(1)).subscribe(routeQueryStringParams => {
      const routeQueryStringParamKeys = Object.keys(routeQueryStringParams);

      if (routeQueryStringParamKeys.length > 0) {
        let preFilteredParams = this.buildParamsFromObject(routeQueryStringParams);

        routeQueryStringParamKeys.forEach(key => {
          const control = this._filterForm.get(key);

          if (control) {
            control.setValue(routeQueryStringParams[key]);
            this._filterForm.markAsDirty();
            this.filtered = true;
          }
        })

        this.repo.getFirstPage(preFilteredParams);
      } else {
        this.repo.getFirstPage(this._defaultParams);
      }
    });
  }
}
